import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  field: {
    width: '100%',
    marginTop: 15
  }
}));
